module.exports = __webpack_public_path__ + "static/image/history/pc/202604_1.ver2_0_2.jpg?282c410d";